$(function() {

  var arrowShape = { x0: 30, x1: 60, y1: 35, x2: 65, y2: 30, x3: 40 };

  // 1st carousel, main
  var $galleryShow = $('.product-gallery__show').flickity({
    pageDots: false,
    prevNextButtons: false,
    cellSelector: '.product-gallery__item',
    sync: '.product-gallery__nav'
  });

  // 2nd carousel, navigation
  var $galleryNav = $('.product-gallery__nav').flickity({
    contain: true,
    pageDots: false,
    cellAlign: 'left',
    arrowShape: arrowShape
  });

  $galleryNav.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
    if ( cellElement ) {
      $galleryShow.flickity( 'select', cellIndex );
    }
  });

  // fancybox

  

});
